export default __webpack_public_path__ + "static/media/1punto.3a6a0abd.png";